import { render, staticRenderFns } from "./OrdenDeCompra.vue?vue&type=template&id=5673344f"
import script from "./OrdenDeCompra.vue?vue&type=script&lang=js"
export * from "./OrdenDeCompra.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports